import { getNames, registerLocale } from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import CurrencyList from "currency-list";
registerLocale(enLocale);

export const en = {
  translation: {
    countries: getNames("en", { select: "official" }),
    currencies: Object.entries(CurrencyList.getAll("en_US")).reduce(
      (acc, [key, value]) => {
        acc[key] = {
          symbol: value.symbol,
          name: `${value.symbol} (${value.name})`,
        };
        return acc;
      },
      {} as Record<string, { symbol: string; name: string }>,
    ),
    errors: {
      required: "Required",
      emailFormat: "Invalid email",
      clientRequired: "Client is required",
      groupLeaderRequired: "One of the clients must be the group leader",
    },
    toast: {
      //services
      getServicesError: "Error getting services",
      getServiceDetailError: "Error getting service",
      serviceCreated: "Service created",
      createServiceError: "Error creating service",
      serviceUpdated: "Service updated",
      updateServiceError: "Error updating service",
      serviceDeleted: "Service deleted",
      deleteServiceError: "Error deleting service",
      //providers
      getProvidersError: "Error getting providers",
      getProviderDetailError: "Error getting provider",
      providerCreated: "Provider created",
      createProviderError: "Error creating provider",
      providerUpdated: "Provider updated",
      updateProviderError: "Error updating provider",
      providerDeleted: "Provider deleted",
      deleteProviderError: "Error deleting provider",
      //guides
      getGuidesError: "Error getting guides",
      getGuideDetailError: "Error getting guide",
      guideCreated: "Guide created",
      createGuideError: "Error creating guide",
      guideUpdated: "Provider updated",
      updateGuideError: "Error updating guide",
      guideDeleted: "Guide deleted",
      deleteGuideError: "Error deleting guide",
      //workers
      getWorkersError: "Error getting workers",
      getWorkerDetailError: "Error getting worker",
      workerCreated: "Worker created",
      createWorkerError: "Error creating worker",
      workerUpdated: "Worker updated",
      updateWorkerError: "Error updating worker",
      workerDeleted: "Worker deleted",
      deleteWorkerError: "Error deleting worker",
      //agencies
      getAgenciesError: "Error getting agencies",
      getAgencyDetailError: "Error getting agency",
      agencyCreated: "Agencies created",
      createAgencyError: "Error creating agency",
      agencyUpdated: "Agency updated",
      updateAgencyError: "Error updating agency",
      agencyDeleted: "Agency deleted",
      deleteAgencyError: "Error deleting agency",
      //tours
      getToursError: "Error getting tours",
      getTourDetailError: "Error getting tour",
      tourCreated: "Tour created",
      createTourError: "Error creating tour",
      tourUpdated: "Tour updated",
      updateTourError: "Error updating tour",
      tourDeleted: "Tour deleted",
      deleteTourError: "Error deleting tour",
      //regions
      getRegionsError: "Error getting regions",
      getRegionDetailError: "Error getting region",
      regionCreated: "Region created",
      createRegionError: "Error creating region",
      regionUpdated: "Region updated",
      updateRegionError: "Error updating region",
      regionDeleted: "Region deleted",
      deleteRegionError: "Error deleting region",
      //tour agencies
      tourAgencyTourCreated: "Tour added to agency",
      tourAgencyAgencyCreated: "Agency added to tour",
      createTourAgencyTourError: "Error adding tour to agency",
      createTourAgencyAgencyError: "Error adding agency to tour",
      tourAgencyTourDeleted: "Tour removed from agency",
      tourAgencyAgencyDeleted: "Agency removed from tour",
      deleteTourAgencyTourError: "Error removing tour from agency",
      deleteTourAgencyAgencyError: "Error removing agency from tour",
      getTourAgencyTourError: "Error getting tours of agency",
      getTourAgencyAgencyError: "Error getting agencies of tour",
      getTourAgencyTourDetailError: "Error getting detail",
      getTourAgencyAgencyDetailError: "Error getting detail",
      tourAgencyTourUpdated: "Tour updated",
      tourAgencyAgencyUpdated: "Agency updated",
      updateTourAgencyTourError: "Error updating tour",
      updateTourAgencyAgencyError: "Error updating agency",
      //service providers
      serviceProviderServiceCreated: "Service added to provider",
      serviceProviderProviderCreated: "Provider added to service",
      createServiceProviderServiceError: "Error adding service to provider",
      createServiceProviderProvierError: "Error adding provider to service",
      serviceProviderServiceDeleted: "Service removed from provider",
      serviceProviderProviderDeleted: "Provider removed from service",
      deleteServiceProviderServiceError: "Error removing service from provider",
      deleteServiceProviderProviderError:
        "Error removing provider from service",
      getServiceProviderServiceError: "Error getting services of provider",
      getServiceProviderProviderError: "Error getting providers of service",
      getServiceProviderServiceDetailError: "Error getting detail",
      getServiceProviderProviderDetailError: "Error getting detail",
      serviceProviderServiceUpdated: "Service updated",
      serviceProviderProviderUpdated: "Provider updated",
      updateServiceProviderServiceError: "Error updating service",
      updateServiceProviderProviderError: "Error updating provider",
      //hotels
      getHotelsError: "Error getting hotels",
      getHotelDetailError: "Error getting hotel",
      hotelCreated: "Hotel created",
      createHotelError: "Error creating hotel",
      hotelUpdated: "Hotel updated",
      updateHotelError: "Error updating hotel",
      hotelDeleted: "Hotel deleted",
      deleteHotelError: "Error deleting hotel",
      //hotel-rooms
      getHotelRoomsError: "Error getting rooms",
      getHotelRoomDetailError: "Error getting room",
      hotelRoomCreated: "Room created",
      createHotelRoomError: "Error creating room",
      hotelRoomUpdated: "Room updated",
      updateHotelRoomError: "Error updating room",
      hotelRoomDeleted: "Room deleted",
      deleteHotelRoomError: "Error deleting room",
      //tour-days
      tourDaysUpdated: "Tour days updated",
      updateTourDaysError: "Error updating tour days",
      // clients
      getClientsError: "Error getting clients",
      getClientDetailError: "Error getting client",
      clientCreated: "Client created",
      createClientError: "Error creating client",
      clientUpdated: "Client updated",
      updateClientError: "Error updating client",
      clientDeleted: "Client deleted",
      deleteClientError: "Error deleting client",
      //reservations
      getReservationsError: "Error getting reservations",
      reservationCreated: "Reservation created",
      createReservationError: "Error creating reservation",
      reservationUpdated: "Reservation updated",
      updateReservationError: "Error updating reservation",
      reservationDeleted: "Reservation deleted",
      deleteReservationError: "Error deleting reservation",
      //fulfillments
      fulfillmentCreated: "Fulfillment created",
      createFulfillmentError: "Error creating fulfillment",
      fulfillmentUpdated: "Fulfillment updated",
      updateFulfillmentError: "Error updating fulfillment",
      fulfillmentDeleted: "Error deleting fulfillment",
      deleteFulfillmentError: "Error deleting fulfillment",
      //departments
      getDepartmentsError: "Error getting departments",
      getDepartmentDetailError: "Error getting department",
      departmentCreated: "Department created",
      createDepartmentError: "Error creating department",
      departmentUpdated: "Department updated",
      updateDepartmentError: "Error updating department",
      departmentDeleted: "Department deleted",
      deleteDepartmentError: "Error deleting department",
      //payments
      getPaymentsError: "Error getting payments",
      getPaymentDetailError: "Error getting payment",
      paymentCreated: "Payment created",
      createPaymentError: "Error creating payment",
      paymentUpdated: "Payment updated",
      updatePaymentError: "Error updating payment",
      paymentDeleted: "Payment deleted",
      deletePaymentError: "Error deleting payment",
      //payment-adjustments
      getPaymentAdjustmentsError: "Error getting payment adjusment",
      paymentAdjustmentCreated: "Payment adjustment created",
      createPaymentAdjustmenttError: "Error creating payment adjustment",
      paymentAdjustmentDeleted: "Payment adjustment deleted",
      deletePaymentAdjustmentError: "Error deleting payment adjustment",
      paymentAdjustmentUpdated: "Payment adjustment updated",
      updatePaymentAdjustmentUpdatedError: "Error updating payment adjustment",
      // email templates
      emailTemplateCreated: "Email template created",
      createEmailTemplateError: "Error creating email template",
      emailTemplateUpdated: "Email template updated",
      updateEmailTemplateError: "Error updating email template",
      emailTemplateDeleted: "Email template deleted",
      deleteEmailTemplateError: "Error deleting email template",
      // triggers
      triggerCreated: "Trigger created",
      createTriggerError: "Error creating trigger",
      triggerUpdated: "Trigger updated",
      updateTriggerError: "Error updating trigger",
      triggerDeleted: "Trigger deleted",
      deleteTriggerError: "Error deleting trigger",
      // ses config
      sesConfigUpdated: "SES configuration updated",
      updateSesConfigError: "Error updating SES configuration",
      //hotel room prices
      hotelRoomPriceCreated: "Hotel Room Price created",
      createHotelRoomPriceError: "Error creating Hotel Room Price",
      getHotelRoomPricesError: "Error getting Hotel Room Prices",
      getHotelRoomPriceDetailError: "Error getting Hotel Room Price Detail",
      hotelRoomPriceUpdated: "Hotel Room Price updated",
      updateHotelRoomPriceError: "Error updating Hotel Room Price",
      hotelRoomPriceDeleted: "Hotel Room Price deleted",
      hotelRoomPriceDeletedError: "Error deleting Hotel Room Price",
    },
    nav: {
      user: {
        themes: {
          title: "Themes",
          light: "Light",
          dark: "Dark",
          system: "System",
        },
      },
    },
    common: {
      active: "active",
      inactive: "inactive",
      noDescription: "No description",
      view: "View",
      save: "Save",
      cancel: "Cancel",
      logout: "Log out",
      delete: "Delete",
      all: "All",
      loadMore: "Load more",
      toggleTableView: "Toggle table view",
      tableActions: "Actions",
      add: "Add",
      back: "Back",
      edit: "Edit",
      createdAt: "Created At",
      updatedAt: "Last Updated",
      inputs: {
        select: {
          noResults: "No results",
          new: "Add new",
        },
        contact: {
          add: "New contact",
          name: "Name",
          type: "Role",
          email: "Email",
          phone: "Phone",
        },
        kv: {
          add: "Add",
          key: "Key",
          value: "Value",
        },
        textlist: {
          add: "Add",
        },
      },
      boolean: {
        true: "Yes",
        false: "No",
      },
      operationRegions: {
        Faro: "Faro",
        Lisbon: "Lisbon",
        Porto: "Porto",
        Madeira: "Madeira",
        Azores: "Azores",
        Marrocos: "Marrocos",
      },
    },
    home: {
      title: "Home",
    },
    templates: {
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      title: "Templates",
    },
    triggers: {
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      title: "Triggers",
    },
    operations: {
      title: "Operations",
      tabs: {
        triggers: "Triggers",
        templates: "Email Templates",
      },
      emailBuilder: {
        visual: "Visual Editor",
        html: "HTML Code",
        text: "Plain Text",
        generateText: "Generate from HTML",
        visualEditorNote: "",
        availableFields: "Available Fields",
        availableFieldsFor: "Available Fields for {{entityType}}",
      },
      triggers: {
        empty: "Empty",
        title: "Email Triggers",
        description: "Configure automated emails based on entity events",
        noTriggers: "No triggers configured yet",

        conditions: {
          add: "Add Condition",
          empty:
            "No conditions set. This trigger will fire for all events of the selected type.",
        },
        new: { title: "New Trigger" },
        edit: {
          title: "Edit Trigger",
          button: "Update Trigger",
        },
        active: "Active",
        inactive: "Inactive",
        details: "Details",
        advanced: "Advanced Settings",
        emailTemplate: "Email Template",
        noTemplate: "No template selected",
        noTemplatesForEntity:
          "No templates available for {{entity}}. Please create a template first.",
        recipients: "Recipients",
        noRecipients: "No recipients configured. Add at least one recipient.",
        addRecipient: "Add Recipient",
        recentEvents: "Recent Events",
        noEvents: "No events recorded for this trigger yet",
        callbackUrlHelp: "Optional URL for RSVP or other response actions",
        fields: {
          name: "Name",
          description: "Description",
          entityType: "Entity Type",
          eventType: "Event Type",
          active: "Active",
          conditionField: "Field",
          conditionOperator: "Operator",
          conditionValue: "Value",
          emailTemplate: "Email Template",
          recipientType: "Recipient Type",
          recipientField: "Field",
          recipientEmail: "Email",
          recipientWorker: "Worker",
          callbackUrl: "Callback URL",
          conditions: "Event Conditions",
          createdAt: "Create Date",
          updatedAt: "Last Update Date",
        },
      },
      templates: {
        empty: "Empty",
        title: "Email Templates",
        description: "Manage email templates for automated communications",
        noTemplates: "No email templates created yet",
        new: { title: "New Template" },
        edit: {
          title: "Edit Email Template",
          button: "Update Template",
        },
        availableFields: "Available Fields",
        details: "Template Details",
        variables: "Template Variables",
        content: "Email Content",
        preview: "Preview",
        html: "HTML",
        text: "Plain Text",
        notFound: "Template not found",
        editor: {
          visual: "Visual Editor",
          html: "Html Editor",
        },
        fields: {
          name: "Template Name",
          subject: "Email Subject",
          entityType: "Entity Type",
          templateType: "Template Type",
          type: "Type",
          content: "Email Content",
          textContent: "Plain Text Version",
          variables: "Template Variables",
          preview: "Preview",
          createdAt: "Create Date",
          updatedAt: "Last Updated Date",
          description: "Description",
          body: "Body",
        },
      },
      events: {
        title: "Email Events",
        sent: "Sent",
        delivered: "Delivered",
        opened: "Opened",
        clicked: "Clicked",
        responded: "Responded",
        bounced: "Bounced",
        complained: "Complained",
      },
    },
    services: {
      title: "Services",
      types: [
        "Labour",
        "Transfer",
        "Meals",
        "Mix Expenses",
        "Fuel",
        "Bikes",
        "Car Rental",
      ],
      paymentModels: ["Unit", "Fixed", "Hourly", "Per kilometre"],
      noType: "No type",
      noDescription: "No description",
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        name: "Name",
        type: "Type",
        description: "Description",
        departmentId: "Department",
        referencePrice: "Reference price",
        paymentModel: "Payment Model",
      },
      new: {
        title: "New service",
        button: "Create new Service",
      },
      update: {
        button: "Update Service",
      },
      delete: {
        button: "Delete Service",
      },
      deletePrompt: {
        title: "Delete service",
        description: "Are you sure you want to delete this service?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    providers: {
      title: "Providers",
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        country: "Country",
        birthdate: "Birthdate",
        language: "Language",
        paymentAfterInvoice: "Payment after invoice",
      },
      new: {
        title: "New Provider",
        button: "Create new Provider",
      },
      update: {
        button: "Update Provider",
      },
      delete: {
        button: "Delete Provider",
      },
      deletePrompt: {
        title: "Delete provider",
        description: "Are you sure you want to delete this provider?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    guides: {
      title: "Guides",
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        country: "Country",
        birthdate: "Birthdate",
        language: "Language",
      },
      new: {
        title: "New Guide",
        button: "Create new Guide",
      },
      update: {
        button: "Update Guide",
      },
      delete: {
        button: "Delete Guide",
      },
      deletePrompt: {
        title: "Delete guide",
        description: "Are you sure you want to delete this guide?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    workers: {
      title: "Workers",
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        country: "Country",
        birthdate: "Birthdate",
        language: "Language",
      },
      new: {
        title: "New Worker",
        button: "Create new Worker",
      },
      update: {
        button: "Update Worker",
      },
      delete: {
        button: "Delete Worker",
      },
      deletePrompt: {
        title: "Delete worker",
        description:
          "Are you sure you want to delete this worker? This worker won't be abe to access the system anymore.",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    agencies: {
      title: "Agencies",
      paymentConditions: {
        Monthly: "Monthly",
        BeforeTour: "Before tour",
        AfterTour: "After tour",
      },
      payment: {
        tourManagement: "tour management",
        Other: "Other",
      },
      digitalBook: {
        tourManagement: "tour management",
        AgencyBranding: "Agency Branding",
        AgencyApp: "Agency App",
        NotNecessary: "Not Necessary",
      },
      navigationApp: {
        "tour-management": "tour management",
        AgencyApp: "Agency App",
        NotNecessary: "Not Necessary",
      },
      toursEnum: {
        tourManagementTours: "tour management Tours",
        Exclusive: "Exclusive",
      },
      guiding: {
        Guided: "Guided",
        SelfGuided: "Self-Guided",
      },
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        name: "Name",
        contacts: "Contacts",
        website: "Website",
        notes: "Notes",
        country: "Country",
        tags: "Tags",
        language: "Language",
        priceCommission: "Price commission",
        seasonSupplementCommission: "Season supplement commission",
        individualRoomSupplementCommission:
          "Individual room supplement commission",
        soloTravelerCommission: "Solo traveler commission",
        bikesCommissions: "Bikes commissions",
        extraNightsCommissions: "Extra nights commissions",
        roomChangeCommissions: "Room change commissions",
        servicesCommissions: "Services commissions",
        paymentConditions: "Payment conditions",
        timeRestraintForDocumentation: "Time restraint for documentation",
        branding: "Branding",
        payment: "Payment",
        details: "Details",
        digitalBook: "Digital book",
        navigationApp: "Navigation app",
        tours: "Tours",
        guiding: "Guiding",
        briefingLanguage: "Briefing language",
        travefyRequired: "Travefy required",
        rwgpsrequired: "Rwgps required",
      },
      new: {
        title: "New Agency",
        button: "Create new Agency",
      },
      update: {
        button: "Update Agency",
      },
      delete: {
        button: "Delete Agency",
      },
      deletePrompt: {
        title: "Delete agency",
        description: "Are you sure you want to delete this agency?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    tours: {
      title: "Tours",
      categories: {
        all: "All",
        Hike: "Hike",
        BikeHybrid: "Bike Hybrid",
        BikeMountain: "Bike Mountain",
        BikeRoad: "Bike Road",
        BikeGravel: "Bike Gravel",
        Mix: "Mix",
      },
      types: {
        all: "All",
        Guided: "Guided",
        SelfGuided: "Self Guided",
        Supported: "Supported",
        Mix: "Mix",
        Services: "Services",
        Internal: "Internal",
      },
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        name: "Name",
        type: "Type",
        category: "Category",
        region: "Region",
        operationRegion: "Operation region",
        tourLeaderId: "Tour leader",
        percentageMap: "Agency Commission",
        details: "Details",
        fixedPrice: "Fixed price",
        seasonalSupplementMap: "Seasonal supplement",
        individualRoomSupplementMap: "Individual room supplement",
        soloTravelerSupplement: "Solo traveler supplement",
        active: "Active",
        exclusivity: "Exclusivity",
      },
      new: {
        title: "New Tour",
        button: "Create new Tour",
      },
      update: {
        button: "Update Tour",
      },
      delete: {
        button: "Delete tour",
      },
      deletePrompt: {
        title: "Delete tour",
        description: "Are you sure you want to delete this tour?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    tourAgencies: {
      agency: {
        title: "Tours",
        contextMenu: {
          new: "Add new",
          edit: "Edit",
          view: "View",
          delete: "Delete",
        },
        new: {
          title: "New Tour",
          button: "Create new Tour",
        },
        update: {
          button: "Update Tour",
        },
        delete: {
          button: "Delete Tour",
        },
        deletePrompt: {
          title: "Delete tour",
          description:
            "Are you sure you want to delete this tour from the agency?",
          proceed: "Delete",
          cancel: "Cancel",
        },
      },
      tour: {
        title: "Agencies",
        contextMenu: {
          new: "Add new",
          edit: "Edit",
          view: "View",
          delete: "Delete",
        },
        new: {
          title: "New Agency",
          button: "Create new Agency",
        },
        update: {
          button: "Update Agency",
        },
        delete: {
          button: "Delete Agency",
        },
        deletePrompt: {
          title: "Delete agency",
          description:
            "Are you sure you want to delete this agency from the tour?",
          proceed: "Delete",
          cancel: "Cancel",
        },
      },
      fields: {
        alias: "Alias",
        agencyId: "Agency",
        tourId: "Tour",
        priceCommission: "Price commission",
        seasonSupplementCommission: "Season supplement commission",
        individualRoomSupplementCommission:
          "Individual room supplement commission",
        soloTravelerCommission: "Solo traveler commission",
        bikesCommissions: "Bikes commissions",
        extraNightsCommissions: "Extra nights commissions",
        roomChangeCommissions: "Room change commissions",
        servicesCommissions: "Services commissions",
      },
    },
    serviceProviders: {
      service: {
        title: "Providers",
        contextMenu: {
          new: "Add new",
          edit: "Edit",
          view: "View",
          delete: "Delete",
        },
        new: {
          title: "New Provider",
          button: "Create new Provider",
        },
        update: {
          button: "Update Provider",
        },
        delete: {
          button: "Delete Provider",
        },
        deletePrompt: {
          title: "Delete provider",
          description:
            "Are you sure you want to remove this provider from the service?",
          proceed: "Delete",
          cancel: "Cancel",
        },
      },
      provider: {
        title: "services",
        contextMenu: {
          new: "Add new",
          edit: "Edit",
          view: "View",
          delete: "Delete",
        },
        new: {
          title: "New Service",
          button: "Create new Service",
        },
        update: {
          button: "Update Service",
        },
        delete: {
          button: "Delete Service",
        },
        deletePrompt: {
          title: "Delete service",
          description:
            "Are you sure you want to remove this service from the provider?",
          proceed: "Delete",
          cancel: "Cancel",
        },
      },
      fields: {
        regionId: "Region",
        requiresPrice: "Requires price",
        price: "Price",
        rating: "Rating",
        serviceId: "Service",
        providerId: "Provider",
        paymentModel: "Payment Model",
      },
    },
    hotels: {
      title: "Hotels",
      categories: {
        Luxury: "Luxury (5* hotel)",
        Historical: "Historical (4*/5*H Historical)",
        Superior: "Superior (4*H / Charming GH)",
        Comfort: "Comfort (3*H / GH)",
        Budget: "Budget (2*H / GH)",
      },
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      info: {
        breakfast: "Breakfast",
      },
      fields: {
        name: "Name",
        socialReason: "Social reason",
        group: "Group",
        category: "Category",
        priority: "Priority",
        address: "Address",
        zipCode: "Zip code",
        locality: "Locality",
        regionId: "Region",
        phoneNumber: "Phone number",
        contacts: "Contacts",
        vat: "VAT",
        paymentAfterInvoice: "Payment after invoice",
        hasBar: "Has BAR",
        bar: "BAR",
        bookingDiscount: "Booking discount",
        iban: "IBAN",
        checkInTime: "Check in",
        checkOutTime: "Check out",
        breakfastStartTime: "Breakfast start",
        breakfastEndTime: "Breakfast end",
        hasPicnic: "Has picnic",
        picnicPrice: "Picnic Price",
        picnicNotes: "Picnic Notes",
        hasDinner: "Has dinner",
        dinnerPrice: "Dinner Price",
        dinnerAutoScheduling: "Dinner needs booking",
        dinnerNotes: "Dinner Notes",
        bikeStorage: "Bike storage",
        bikeStoragePrice: "Bike storage price",
        bikeStorageQuantity: "Bike storage quantity",
        bikeNotes: "Bike notes",
        petFriendly: "Pet friendly",
        petNotes: "Pet notes",
        kidFriendly: "Kid friendly",
        childMaxAge: "Max age for kids",
        internalObservations: "Internal observations",
        externalObservations: "External observations",
      },
      new: {
        title: "New Hotel",
        button: "Create new hotel",
      },
      update: {
        button: "Update Hotel",
      },
      delete: {
        button: "Delete Hotel",
      },
      deletePrompt: {
        title: "Delete hotel",
        description: "Are you sure you want to delete this hotel?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    hotelRooms: {
      title: "Rooms",
      deleteType: "Delete type",
      types: {
        Twin: "Twin",
        Double: "Double",
        DSU: "DSU",
        Triple: "Triple",
        Other: "Other",
      },
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        designation: "Designation",
        count: "Number of rooms",
        notes: "Notes",
        earlyBookingDiscountDays: "Early Booking discount (days)",
        extraBeds: "Extra beds",
        averageExtraBedRateMap: "Extra bed rate",
        bookingDiscountMap: "Booking discounts",
        pricing: "Pricing",
        roomNotes: "Room notes",
      },
      new: {
        title: "New Room",
        button: "Create new Room",
      },
      update: {
        button: "Update Room",
      },
      delete: {
        button: "Delete Room",
      },
      deletePrompt: {
        title: "Delete room",
        description: "Are you sure you want to delete this room?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    tourDays: {
      title: "Days",
      day: {
        new: "New day",
        updateName: "Edit name",
        delete: "Delete Day",
      },
      service: {
        title: "Services",
        new: "New",
        edit: "Edit Service",
        delete: "Delete Service",
        provider: "Provider ",
        create: "Create",
        update: "Update",
        fields: {
          startHour: "Start",
          endHour: "End",
          serviceId: "Service",
          serviceProviderId: "Provider",
        },
      },
      accommodation: {
        title: "Accommodations",
        main: " Main Accommodation",
        new: "New",
        edit: "Edit",
        delete: "Delete",
        create: "Create",
        update: "Update",
        fields: {
          hotelRoomId: "Room",
        },
        "hotel-booking-declined": "Declined",
      },
    },
    reservations: {
      title: "Reservations",
      tourStandard: {
        Standard: "Standard",
        HotelsChanged: "Hotels changed",
        TailorMade: "Tailor made",
      },
      state: {
        Pending: "Pending",
        Confirmed: "Confirmed",
        Canceled: "Canceled",
        NoShow: "No Show",
        OnGoing: "Ongoing",
        Completed: "Completed",
        Refunded: "Refunded",
      },
      servicesState: {
        NO: "NO",
        SentToProvider: "Sent to Provider",
        Ongoing: "Ongoing",
        Phone: "Phone",
        PreBooking: "Pre-Booking",
        OK: "OK",
        Done: "Done",
        PercentDone: "%Done%",
        NotDone: "Not Done",
        Canceled: "Canceled",
      },
      tags: {
        Yes: "Yes",
        No: "No",
        NotNeeded: "Not Needed",
        Work: "Work",
      },
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      form: {
        tabs: {
          details: "Details",
          clients: "Clients",
          schedule: "Schedule",
        },
        clients: {
          new: "Add new client",
          createButton: "Add client",
          updateButton: "Update client",
          editPersonalInfo: "Edit Personal Information",
          leader: "Group Leader",
          fields: {
            clientId: "Client",
            needsBike: "Needs Bike",
            arrivalDetails: "Arrival Details",
            departureDetails: "Departure Details",
            name: "Name",
            email: "Email",
            phone: "Phone",
            birthdate: "Birthdate",
            country: "Country",
            language: "Language",
            height: "Height",
            allergies: "Allergies",
            dietaryRestrictions: "Dietary Restrictions",
            emergencyContact: "Emergency Contact",
            ensured: "Ensured",
            inseam: "Inseam",
            medicalConditions: "Medical Conditions",
            passportExpiration: "Passport Expiration",
            passportNumber: "Passport Number",
          },
        },
        schedule: {
          newDay: "New day",
          updateName: "Edit name",
          delete: "Delete Day",
          service: {
            title: "Services",
            new: "New",
            edit: "Edit Service",
            delete: "Delete Service",
            create: "Create",
            update: "Update",
            participants: {
              title: "Participants",
              add: "Add client",
            },
            fields: {
              startHour: "Start",
              endHour: "End",
              serviceId: "Service",
              serviceProviderId: "Provider",
              price: "Price",
              state: "State",
              notes: "Notes",
              clientNotes: "Client Notes",
            },
          },
          accommodations: {
            title: "Accommodations",
            new: "New",
            requestedTypes: {
              requestedType: "Requested Type",
              requestedType1: "Requested Type 1",
            },
            states: {
              No: "No",
              SentToHotel: "Sent to Hotel",
              Ongoing: "Ongoing",
              Phone: "Phone",
              PreBooking: "Pre-Booking",
              Ok: "Ok",
              OkPromo: "Ok (promo)",
              SelfBooked: "Self-Booked",
              BookingCom: "Booking.com",
              Canceled: "Canceled",
            },
            create: "Create",
            update: "Update",
            delete: "Delete",

            fields: {
              hotelId: "Hotel",
              hotelRoomId: "Hotel room",
              requestedType: "Requested Type",
              state: "State",
              childrenCount: "Children",
              headCount: "Number of people",
              expenses: "Expenses",
              numberOfBeds: "Number of beds",
              price: "Price",
              invoiceNumber: "Invoice number",
              release: "Release",
              notes: "Notes",
            },
            occupants: {
              count: "Occupants: {{count}}",
              title: "Occupants",
              add: "Add client",
              delete: "Remove client",
            },
          },
        },
      },
      fields: {
        groupLeaderId: "Group Leader",
        tourStandart: "Tour Standart",
        begin: "Begin",
        end: "End",
        workerId: "Worker",
        tourAgencyId: "Tour",
        agency: "Agency",
        operationRegion: "Operation Region",
        tourLeaderId: "Tour Leader",
        agencyReservationNumber: "Agency Reservation Number",
        documentationSentDate: "Documentation Sent Date",
        bookingDate: "Booking Date",
        confirmedDate: "Confirmed Date",
        state: "State",
        details: "Details",
        rwgpsrequired: "Ride With GPS",
        rwgpslinks: "Ride With GPS Links",
        travefyRequired: "Travefy",
        tfylinks: "Travefy Links",
        gpxRequired: "GPX",
        gpxlinks: "GPX Links",
        dropboxRequired: "Dropbox",
        dropboxLinks: "Dropbox Links",
        feedbackRequired: "Feedback",
        feedbackLinks: "Feedback Links",
        customLinks: "Custom Links",
        travefySent: "Travefy Sent",
        rwgpsSent: "Rwgps Sent",
        gpxSent: "Gpx Sent",
      },
      details: {
        agency: "Agency",
        tour: "Tour",
        dates: "Dates",
      },
      new: {
        title: "New Reservation",
        button: "Create new Reservations",
      },
      update: {
        title: "Edit Reservation",
        button: "Update Reservations",
      },
      delete: {
        button: "Delete Reservation",
      },
      deletePrompt: {
        title: "Delete reservation",
        description: "Are you sure you want to delete this reservation?",
        proceed: "Delete",
        cancel: "Cancel",
      },
      nextButton: "Next step",
      prevButton: "Previous step",
      calendar: {
        title: "Calendar",
        contextMenu: {
          new: "Add new",
        },
      },
      list: {
        title: "List",
      },
      fulfillments: {
        state: {
          NotPayed: "Not payed",
          Payed: "Payed",
        },
        title: "Fulfillments",
        hotels: {
          title: "Hotels fulfillments",
          contextMenu: {
            new: "New Hotel Fulfillment",
          },
        },
        service: {
          title: "Services fulfillments",
          contextMenu: {
            new: "New Service Fulfillment",
          },
        },
        contextMenu: {
          edit: "Edit",
          delete: "Delete",
        },
        deletePrompt: {
          title: "Delete Fulfillment",
          description: "Are you sure you want to delete this fulfillment?",
          proceed: "Delete",
          cancel: "Cancel",
        },
        services: "Services",
        accommodations: "Accommodations",
        new: {
          title: "New fulfillment",
          button: "Create",
        },
        edit: {
          title: "Edit fulfillment",
          button: "Update",
        },
        table: {
          hotel: "Hotel",
          service: "Service",
          value: "Value",
          dueDate: "Due date",
          state: "State",
          agencyCharge: "Agency charge",
          expenses: "Expenses",
          invoiceNumber: "Invoice number",
          serviceProviderId: "Provider",
        },
        fields: {
          balance: "Balance: {{balance}} €, ",
          total: "Total: {{total}} €",
          state: "State",
          value: "Value",
          dueDate: "Due date",
          invoiceNumber: "Invoice number",
          serviceProvider: "Provider",
        },
      },
    },
    paymentAdjustments: {
      title: "Payment Adjustments",
      fields: {
        type: "Type",
        total: "Total",
        reservationId: "Reservation Id",
        pvp: "PVP",
        markup: "Markup",
        comissions: "Comissions",
        quantity: "Quantity",
        client: "Client",
        discount: "Discount",
        reservationClients: "Clients",
      },
      contextMenu: {
        new: "New",
      },
      new: {
        title: "New Payment Adjustment",
        button: "Create Payment Adjustment",
      },
      update: {
        title: "Edit Payment Adjustment",
        button: "Update Payment Adjustment",
      },
      types: {
        Tour: "Tour",
        Season: "Season",
        Individual_Room: "Individual Room",
        Solo_Supplement: "Solo Supplement",
        Transfers: "Transfers",
        Luggage: "Luggage",
        Custom: "Custom",
      },
      deletePrompt: {
        title: "Delete Payment Adjustment",
        description: "Are you sure you want to delete this Payment Adjustment",
        cancel: "Cancel",
        proceed: "Delete",
      },
    },
    more: {
      title: "More",
    },
    regions: {
      title: "Regions",
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        name: "Name",
        description: "Description",
        color: "Color",
      },
      new: {
        title: "New Region",
        button: "Create new Region",
      },
      update: {
        button: "Update Region",
      },
      delete: {
        button: "Delete Region",
      },
      deletePrompt: {
        title: "Delete region",
        description: "Are you sure you want to delete this region?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    departments: {
      title: "Departments",
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        name: "Name",
        description: "Description",
      },
      new: {
        title: "New Department",
        button: "Create new Department",
      },
      update: {
        button: "Update Department",
      },
      delete: {
        button: "Delete Department",
      },
      deletePrompt: {
        title: "Delete department",
        description: "Are you sure you want to delete this department?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
    payments: {
      title: "Payments",
      depositsTitle: "Deposits",
      balancesTitle: "Balance",
      state: {
        Payed: "Payed",
        Sent: "Sent",
        No: "No",
      },
      methods: {
        Cash: "Cash",
        CreditCard: "Credit card",
        BankTransfer: "Bank transfer",
        Check: "Check",
        Paypal: "Paypal",
        Other: "Other",
      },
      contextMenu: {
        new: "Add new",
        edit: "Edit",
        view: "View",
        delete: "Delete",
      },
      fields: {
        value: "Value",
        state: "State",
        isDeposit: "Is deposit",
        paymentMethod: "Payment method",
        currency: "Currency",
        paymentDate: "Payment date",
        invoice: "Invoice",
        invoiceUrl: "Invoice link",
        notes: "Notes",
        payee: "Payee",
        balance: "Amount payed",
      },
      new: {
        title: "New Payment",
        deposit: {
          title: "New Deposit",
          button: "Create new deposit",
        },
        balance: {
          title: "New balance",
          button: "Create new balance",
        },
      },
      update: {
        button: "Update payment",
        deposit: {
          title: "Update Deposit",
          button: "Update deposit",
        },
        balance: {
          title: "Update balance",
          button: "Update new balance",
        },
      },
      delete: {
        button: "Delete payment",
      },
      deletePrompt: {
        title: "Delete payment",
        description: "Are you sure you want to delete this payment?",
        proceed: "Delete",
        cancel: "Cancel",
      },
    },
  },
};
